import type { InputMode } from '@brighterly/lib-core-types/ui/inputs/types'

import { getMode } from '@shared/lib/mode'

import { useTutorApplicationStore } from '../store'

interface LegalAgreementsReturn {
  mode: ComputedRef<InputMode>
  label: string
  setAcceptConfidentiality: () => void
}

export const useAcceptConfidentiality = (): LegalAgreementsReturn => {
  const tutorApplicationStore = useTutorApplicationStore()

  const label = 'I understand that the hiring process is a strictly confidential matter and I hereby agree not to disclose any data regarding the process, such as emails, video recordings, photos, documents, etc. Any violation shall result in the removal of your application from the process.'

  const mode = computed(() => getMode(tutorApplicationStore.getShowErrors && !tutorApplicationStore.acceptConfidentiality))

  const setAcceptConfidentiality = (): void => {
    tutorApplicationStore.setAcceptConfidentiality(!tutorApplicationStore.acceptConfidentiality)
  }

  return {
    mode,
    label,
    setAcceptConfidentiality,
  }
}
